import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsDashboard = ({ metrics }) => {
  const metricCards = [
    {
      icon: 'TrendingUp',
      label: 'Total Successful Placements',
      value: metrics?.totalPlacements,
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'DollarSign',
      label: 'Total Transfer Value',
      value: metrics?.totalValue,
      color: 'secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      icon: 'Target',
      label: 'Success Rate',
      value: metrics?.successRate,
      color: 'success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Users',
      label: 'Active Players',
      value: metrics?.activePlayers,
      color: 'accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6 mb-6 md:mb-8">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-md p-4 md:p-5 lg:p-6 hover:shadow-elevated transition-shadow duration-300"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-12 h-12 md:w-14 md:h-14 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon
                name={metric?.icon}
                size={24}
                color={`var(--color-${metric?.color})`}
              />
            </div>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-headline mb-1">
            {metric?.value}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground">
            {metric?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default MetricsDashboard;